import WidgetModule from "@eisinc/Overrides/Widgets/CheckoutShipping/EditExistingAddressModal";

export * from "@eisinc/Overrides/Widgets/CheckoutShipping/EditExistingAddressModal";

export default WidgetModule;
